<div class="content-container">
  <div class="top-nav-container">
    @if (pageIndex > 0) {
      <button
        class="arrow-button"
        (click)="setPageIndex(pageIndex - 1)"
        aria-label="Previous page"
        aria-controls="page-content"
        [attr.aria-disabled]="pageIndex === 0 ? 'true' : null"
        >
        <mat-icon>arrow_back</mat-icon>
      </button>
    }
    @if (pageIndex === 0) {
      <div
        class="fake-arrow-button"
        aria-hidden="true"
      ></div>
    }
    <div class="nav-center">
      @for (page of pages; track page; let i = $index) {
        @if (pageIndex === i) {
          <h1 role="heading" aria-live="assertive">
            {{ page }}
          </h1>
        }
      }
    </div>
    @if (pageIndex < pages.length - 1) {
      <button
        class="arrow-button"
        (click)="setPageIndex(pageIndex + 1)"
        aria-label="Next page"
        aria-controls="page-content"
        [attr.aria-disabled]="pageIndex === pages.length - 1 ? 'true' : null"
        >
        <mat-icon>arrow_forward</mat-icon>
      </button>
    }
    @if (pageIndex === pages.length - 1) {
      <div
        class="fake-arrow-button"
        aria-hidden="true"
      ></div>
    }
  </div>
  <div class="content-div">
    <app-welcome [class.page-hidden]="pageIndex !== 0"></app-welcome>
    <app-project-overview
      [class.page-hidden]="pageIndex !== 1"
    ></app-project-overview>
    <app-environmental
      [class.page-hidden]="pageIndex !== 2"
    ></app-environmental>
    <app-traffic [class.page-hidden]="pageIndex !== 3"></app-traffic>
    <app-alternatives [class.page-hidden]="pageIndex !== 4"></app-alternatives>
    <app-public-comment
      [class.page-hidden]="pageIndex !== 5"
    ></app-public-comment>
  </div>
</div>
